import { EDocumentCategory } from "../../types/document.types";
import { ERegistrationDocumentType } from "../../types/registration.types";
export var getDocumentCategoryId = function (params) {
    var documentType = params.documentType;
    switch (documentType) {
        case ERegistrationDocumentType.Addendum:
            return EDocumentCategory.ContractAddendum;
        case ERegistrationDocumentType.Contract:
            return EDocumentCategory.Contract;
        case ERegistrationDocumentType.PropertyInspectionReport:
            return EDocumentCategory.LocationDescription;
        default:
            return EDocumentCategory.Other;
    }
};
